<iframe [src]="url | safe:'resourceUrl' " style="overflow:hidden" scrolling="no" frameborder="0"></iframe>